import type {
  ProjectExperiments,
  SessionExperiments,
  UserExperiments,
} from '../experiments';

export const sessionExperiments: Partial<SessionExperiments> = {
  'T322479-pjp-project-budget-order-test': 'control',
  'T314575-pjp-email-and-phone-verify-redesign-v2': 'control',
};

export const userExperiments: Partial<UserExperiments> = {
  'T314952-llm-bid-search-noop': 'control',
  'T111865-logged-in-pjp-live-chat-just-enrollment': 'control',
  'T90189-image-thumbnail-service': 'control',
  webapp_playground_test: 'control',
  'T195472-web-push-notifications': 'control',
  'T281208-group-search-by-name': 'control',
  'T299134-activation-remarketing-release-milestone': 'control',
  'T308216-newsfeed-project-bids-noop': 'control',
  'T320735-bid-relevancy-classifier-noop': 'control',
  'T297635-portfolio-on-bid-card-noop-v3': 'control',
  'T314762-menu-redesign-noop': 'control',
  'T308653-bid-list-filter-migration': 'control',
  'T315009-menu-redesign': 'control',
  'T312457-milestone-newsfeed': 'control',
  'T321128-pvp-redesign': 'control',
  'T318664-pvp-redesign-noop-v2': 'control',
  'T322080-prompt-2fa-upsell-noop': 'control',
  'T311153-only-show-recurable-payment-methods-for-monthly-membership-noop':
    'control',
};
export const projectExperiments: Partial<ProjectExperiments> = {};

export const isWhitelistUser = false;

export const shouldEnrol = true;
